import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Button, Tag, Skeleton, Space, message, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined, ArrowLeftOutlined, PushpinOutlined, PushpinFilled } from '@ant-design/icons';
import { useNoteStore } from '../stores/noteStore';
import MDEditor from '@uiw/react-md-editor';

const NotePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isEditMode = searchParams.get('edit') === 'true';
  
  const { currentNote, fetchNote, isLoading, deleteNote, togglePinNote } = useNoteStore();
  
  useEffect(() => {
    if (id) {
      fetchNote(id);
    }
  }, [id, fetchNote]);
  
  const handleDelete = async () => {
    const result = await deleteNote(id);
    if (result.success) {
      message.success('Note deleted');
      navigate('/notes');
    } else {
      message.error(result.message);
    }
  };
  
  const handleTogglePin = async () => {
    if (!currentNote) return;
    
    const result = await togglePinNote(id, currentNote.is_pinned);
    if (!result.success) {
      message.error(result.message);
    }
  };
  
  if (isLoading || !currentNote) {
    return (
      <Card>
        <Skeleton active paragraph={{ rows: 10 }} />
      </Card>
    );
  }
  
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Space>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/notes')}
          >
            Back
          </Button>
          <Button 
            type="primary" 
            icon={<EditOutlined />}
            onClick={() => navigate(`/notes/${id}?edit=true`)}
          >
            Edit
          </Button>
          <Button 
            icon={currentNote.is_pinned ? <PushpinFilled /> : <PushpinOutlined />}
            onClick={handleTogglePin}
          >
            {currentNote.is_pinned ? 'Unpin' : 'Pin'}
          </Button>
          <Button 
            danger 
            icon={<DeleteOutlined />}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </Space>
      </div>
      
      <Card
        title={
          <div style={{ fontSize: '1.5rem' }}>
            {currentNote.is_pinned && <PushpinFilled style={{ color: '#1890ff', marginRight: 8 }} />}
            {currentNote.title}
          </div>
        }
        extra={
          <Space>
            {currentNote.tags?.map(tag => (
              <Tag key={tag.id} color={tag.color || '#108ee9'}>
                {tag.name}
              </Tag>
            ))}
          </Space>
        }
      >
        {currentNote.summary && (
          <div style={{ marginBottom: 16, padding: 16, background: '#f5f5f5', borderRadius: 4 }}>
            <b>Summary:</b> {currentNote.summary}
          </div>
        )}
        
                                                     <div data-color-mode="light" style={{ minHeight: '1000px' }}>
                        <div style={{ overflowY: 'auto', height: '600px' }}>
                          <MDEditor.Markdown 
                            source={currentNote.content} 
                            style={{ padding: 16 }}
                          />
                        </div>
                      </div>
        
        {currentNote.source_url && (
          <div style={{ marginTop: 16 }}>
            <a href={currentNote.source_url} target="_blank" rel="noopener noreferrer">
              View original
            </a>
          </div>
        )}
      </Card>
    </div>
  );
};

export default NotePage;
